// NOTE: This allows settings to be compiled with the code as opposed to
// needing to execute an http request to get settings, this means that settings
// can also be used in app startup for things such as MSAL, datadog, and app
// insights. The ID in the settings file HAS to line up with what is being
// searched for in the predeploy script and also HAS to be the first value in
// the list of vars

import { StaticProvider } from '@angular/core';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { KIG_SETTINGS, KigSettings } from './kig-settings';
import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

const msalLoggerCallback = (logLevel: LogLevel, message: string) => {
  console.log(`[MSAL][${LogLevel[logLevel]}]: ${message}`);
};

export const settings = {
  beginToken: '81162727-7245-4058-88b0-38db22f8737f',
  msal: {
    config: {
      auth: {
        clientId: '195941de-99ab-46b3-9428-57405be152b1',
        authority: 'https://login.microsoftonline.com/db505480-8ec6-495c-b579-32c58ed84a01',
        redirectUri: 'http://localhost:4200/postlogin',
        postLogoutRedirectUri: 'http://localhost:4200/',
        navigateToLoginRequestUrl: false,
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
      }
    },
    guard: {
      interactionType: 'redirect'
    },
    interceptor: {
      unprotectedResources: ['version.json'],
      protectedResourceMap: [
        ['https://graph.microsoft.com/v1.0/users', ['user.read', 'user.readbasic.all']],
        ['https://graph.microsoft.com/v1.0/', ['user.read', 'User.ReadBasic.All']],
        ['https://localhost:44341', ['api://195941de-99ab-46b3-9428-57405be152b1/user_impersonation']],
      ],
    }
  },
  envName: 'Local',
  apiUrl: 'https://localhost:44341',
  graphUrl: 'https://graph.microsoft.com/v1.0/',
  googleIconUrl: 'http://maps.google.com/mapfiles/ms/micons/red.png',
  title: 'Keep It Green',
  appInsightsConnectionString: 'InstrumentationKey=be3d76df-e070-4d22-8569-f0b5c648362d;IngestionEndpoint=https://northcentralus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://northcentralus.livediagnostics.monitor.azure.com/',

  endToken: '4daa9ca3-3ea3-4873-82c5-168cfc5864ae'
};


export class Settings {
  public static initializeProviders(): StaticProvider[] {
    const kigSettings: KigSettings = {
      apiUrl: settings.apiUrl,
      environment: settings.envName,
      googleIconUrl: settings.googleIconUrl,
      graphUrl: settings.graphUrl,
      envName: settings.envName,
      appInsightsConnectionString: settings.appInsightsConnectionString
    };

    return [
      {
        provide: MSAL_INSTANCE, useValue: new PublicClientApplication({
          auth: settings.msal.config.auth,
          cache: settings.msal.config.cache,
          system: {
            loggerOptions: {
              loggerCallback: msalLoggerCallback,
              logLevel: LogLevel.Warning,
              piiLoggingEnabled: false
            }
          }
        })
      },
      {
        provide: MSAL_GUARD_CONFIG, useValue: { ...settings.msal.guard }
      },
      {
        provide: MSAL_INTERCEPTOR_CONFIG,
        // @ts-ignore
        useValue: { protectedResourceMap: new Map(settings.msal.interceptor.protectedResourceMap) }
      },
      { provide: KIG_SETTINGS, useValue: kigSettings },
    ];
  }
}
